import XkhomeBut from './src/homeBut.vue'

XkhomeBut.install = function (Vue) {
  Vue.component(XkhomeBut.name, XkhomeBut)
}

export default XkhomeBut



// WEBPACK FOOTER //
// ./src/components/module/homeBut/index.js